<template>
    <div class="newsitem"  @click="gotoNews(item.ID)">
        <div class="img"><img :src="'http://donghao.chinadonghao.com/upload/'+item.SMALLPIC" alt=""></div>
        <div class="content">
            <div class="tit">{{item.TITLE}}</div>
            <div class="txt">{{item.JJ}}</div>
            <div class="date">{{item.SHOWTIME.substring(0, 10)}}</div>
            <div class="details"><i class="fa fa-arrow-circle-right"></i> 查看详情</div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  methods: {
    gotoNews (id) {
       this.$router.push({
         name: 'newsdetail',
         params: {
           tid: this.item.NEWTYPE,
           id
         }
       })

      /* const { href } = this.$router.resolve({
        name: 'product',
        params: {
          tid: this.currenttid,
          id
        }
      })
      window.open(href, '_blank') */
    }
  }
}
</script>

<style scoped>
.newsitem{
    transition: 3s;
    margin: 50px 30px;
    cursor: pointer;
}
.newsitem:hover{
    box-shadow: 0 0 30px 10px rgba(0,0,0,0.3)
}
.newsitem .img{
    overflow: hidden;
}
.newsitem .img img{
    width: 100%;
    transition: 3s;
    display: block;
}
.newsitem:hover .img img{
    transform: scale(1.2);
}
.newsitem .content{
    padding: 12px 17px;
}
.newsitem .content .tit{
    font-size: 16px;
    color: #000;
}
.newsitem .content .txt{
    font-size: 12px;
    color: #535353;
    line-height: 26px;
}
.newsitem .content .date{
    font-size: 12px;
    color: #3d3d3d;
    padding: 12px 0;
    margin-top: 30px;
    position: relative;
}
.newsitem .content .date::before{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 15px;
    height: 1px;
    background-color: #004b94;
}
.newsitem .content .details{
    font-size: 12px;
    color: #181818;
    transition: .3s;
}
.newsitem .content .details i{
    transition: .3s;
    font-size: 20px;
}
.newsitem:hover .content .details{
    color: #004b94;
}
</style>


